import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { BooleanField, Datagrid, DateField, ListContextProvider, Pagination, TextField, useList } from "react-admin";
import dataProvider from "../../../providers/data-provider";
import EvaluateButton from "../../../resources/activities/evaluate-button";
import { getUrl } from "../../../utils/urls";
import { TimeIconField } from "../../time-icon-field";
;

const TeacherDashboardPendingGrades = (props) => {

    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [value, setValue] = useState('pending');
    const [filter, setFilter] = useState({ evaluated: false })
    const [loaded, setLoaded] = useState(false)
    const [loading, setLoading] = useState(true)
    const [perPage, setPerPage] = useState(10)

    useEffect(() => {
        (async () => {
            setLoaded(false)
            setLoading(true)
            const resp = await dataProvider.get('teacher', 'activity-dashboard', { filter: JSON.stringify(filter), page, limit: perPage })
            setData(resp.data.data)
            setTotal(resp.data.total)
            setLoading(false)
            setLoaded(true)
        })()
    }, [filter, page, perPage])

    const ids = data.map((row) => row.id)
    const sort = { field: 'id', order: 'DESC' };
    const context = useList({ data, ids, loading, loaded, page, perPage, sort, filter })

    const handleChange = (event) => {
        let value = event.target.value;

        setValue(value);

        switch (value) {

            case 'all':
                setFilter({})
                break;

            case 'pending':
            default:
                setFilter({ evaluated: false })
                break;

            case 'evaluated':
                setFilter({ evaluated: true })
                break;

        }
    };

    return (
        <>
            <FormControl style={{ marginBlock: '10px', marginInline: '10px', minWidth: '150px' }}>
                <InputLabel id={'filter-select-label'}>Filtro</InputLabel>
                <Select labelId={'filter-select-label'} id={'filter-select'} value={value} disabled={loading} onChange={handleChange} variant="filled">
                    <MenuItem value={'all'}> Todos</MenuItem>
                    <MenuItem value={'pending'}>Não corrigidas</MenuItem>
                    <MenuItem value={'evaluated'}>Corrigidas</MenuItem>
                </Select>
            </FormControl>

            <Divider />
            <ListContextProvider value={context}>
                <Datagrid loaded={context.loaded} basePath="/activities" resource="activity">
                    <TimeIconField source="effective_deadline" label={'Legenda'} />
                    <TextField source="process.alias" label={'Protocolo'} />
                    <TextField source="process.client.name" label={'Cliente'} />
                    <TextField source="type.name" label={'Movimentação'} />
                    <DateField source="deadline" label={'Prazo aluno'} />
                    <DateField source="effective_deadline" label={'Prazo final'} />
                    <BooleanField source='evaluated' label={'Corrigido?'} />
                    <TextField source="institution_branch.name" label={'Unidade'} />
                    <ActivityButton />
                    <EvaluateButton />
                </Datagrid>
                <Pagination total={total} page={page} setPage={setPage} setPerPage={setPerPage} perPage={perPage} rowsPerPageOptions={[5, 10, 25]} />
            </ListContextProvider>
        </>
    )
}

const ActivityButton = ({ record, resource, ...props }) => {
    return (
        <Button href={
            resource === 'activity' ?
                `${getUrl()}/#/activities/${record.id}` :
                `${getUrl()}/#/activities/${record.activity.id}`
        }
            color="primary"
            target={'_blank'}
            startIcon={<Edit />}
        >
            Movimentação
        </Button>
    )
}

export default TeacherDashboardPendingGrades